import { Stack } from '@mantine/core'
import type { SignatureTask } from '@seen/core/models/tasks/signature/signatureTask'
import type { JSX } from 'react'
import { SignatureTable } from '#src/components/signature/SignatureTable.tsx'

export function Signatures({
  signatures,
  instructions,
  showDiscipline,
}: {
  signatures: SignatureTask[]
  instructions?: string
  showDiscipline?: boolean
}): JSX.Element {
  return (
    <Stack>
      <p>{instructions ?? 'Please review and sign to approve'}</p>
      <SignatureTable signatures={signatures} showDiscipline={showDiscipline} />
    </Stack>
  )
}
